import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-container">
        <div className="footer-logo">
          <img 
            src="/images/Solectric_footer.svg" 
            alt="Solectric Group" 
            className="footer-logo-img"
          />
        </div>
        <div className="footer-top-right">
          <div className="footer-social-icons">
            <a href="https://www.facebook.com/profile.php?id=61585434958223" target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="Facebook">
              <img src="/images/fb_icon.svg" alt="Facebook" className="social-icon" />
            </a>
            <a href="https://www.linkedin.com/company/soluciones-el%C3%A9ctricas-especiales-de-panam%C3%A1-s-a/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="LinkedIn">
              <img src="/images/Linkedin_icon.svg" alt="LinkedIn" className="social-icon" />
            </a>
            <a href="https://www.instagram.com/solectricgroup/" target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="Instagram">
              <img src="/images/ig_icon.svg" alt="Instagram" className="social-icon" />
            </a>
          </div>
          <p className="footer-copyright">Solectric ©. All rights reserved.</p>
        </div>

        <div className="footer-bottom">
          <div className="footer-column">
            <h3 className="footer-title">CONTACTO DIRECTO</h3>
            <p className="footer-text">Tel: <a href="tel:+5073721960" className="footer-link">(507) 372-1960</a></p>
            <p className="footer-text">Cel: <a href="tel:+50768228836" className="footer-link">(507) 6822-8836</a></p>
            <p className="footer-text">Email: <a href="mailto:info@solectric.com.pa" className="footer-link">info@solectric.com.pa</a></p>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">OFICINA CORPORATIVA</h3>
            <p className="footer-text">
              <a href="https://maps.app.goo.gl/73f1Dq4Cht4Y9yCa6" target="_blank" rel="noopener noreferrer" className="footer-link">
                Torre Bicsa Piso 30<br />Oficina 3008<br />Ciudad Panamá
              </a>
            </p>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">SUCURSAL DE VENTAS</h3>
            <p className="footer-text">
              <a href="https://maps.app.goo.gl/UMUJnW6rWRk3icESA" target="_blank" rel="noopener noreferrer" className="footer-link">
                Cárdenas, Plaza Cárdenas<br />Center, local A-1<br />Ciudad de Panamá, Ancon
              </a>
            </p>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">HORARIO DE ATENCIÓN</h3>
            <p className="footer-text">L–V: 08:00–19:00</p>
            <p className="footer-text">S: 08:00–12:00</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
